import React from 'react';
import BaseForm from '@its/components/lib/Container components/FormContainer/BaseForm';
import {
  UserPermissionContainer,
} from '@its/components/lib/Container components/UserContainer/UserPermissionContainer';
import {
  developer,
  admin,
  config,
} from '@its/components/lib/Container components/UserContainer/roles';
import {
  generalDataText,
  ExampleTimerName,
  ExampleFrequency,
  Frequency,
  IsActive,
} from '../../i18n/intl';
import {
  cancelText,
  submitText,
  nameText,
} from '@its/components/lib/util/i18n';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.config = {
      submitText,
      cancelText,
      groups: [
        {
          key: 'generalData',
          title: generalDataText,
          fields: {
            name: {
              hintText: ExampleTimerName,
              floatingLabelText: nameText,
              validators: {
                required: true,
                maxLength: 128,
              },
            },
            iterationTimer: {
              hintText: ExampleFrequency,
              floatingLabelText: Frequency,
              validators: {
                type: 'number',
                required: true,
              },
            },
            isActive: {
              type: 'toggle',
              label: IsActive,
            },
          },
        },
      ],
    };
  }

  render() {
    return (
      <UserPermissionContainer
        allowedRoles={[developer, admin, config]}
        showError
      >
        <BaseForm
          config={this.config}
          {...this.props}
        />
      </UserPermissionContainer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Timer/TimerForm.js
 **/